// StripeProvider
import React, { Component } from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements';
import { connect } from 'react-redux';
import getConfig from './actions/getConfig';
import getLanguage from './actions/getLanguage';
import Form from './Form';


class StripeProv extends Component {

    async componentDidMount() {
        const { actions } = this.props;
        await actions.getConfig();
        await actions.getLanguage();
    }

    render() {

        const stripeForm = (this.props.data && this.props.data.config) &&
        <StripeProvider apiKey={process.env.REACT_APP_STRIPEPUBLICKEY}>
            <Elements>
                <Form />
            </Elements>
        </StripeProvider>

        return (
            <div>
                {stripeForm}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    data: {
      config: state.getConfig.config.data,
      language: state.getLanguage.config.data
    }
  });
  
  const mapDispatchToProps = (dispatch) => ({
    actions: {
      getConfig: () => {
        dispatch(getConfig());
      },
      getLanguage: () => {
        dispatch(getLanguage());
      }
    }
  });

const ConnectedStripeProv = connect(
    mapStateToProps,
    mapDispatchToProps
  )(StripeProv);

export default ConnectedStripeProv;
